import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, retry } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getSessionId } from '../../../helpers/storageUtils';
import { UtilsService } from '../../../services/utils.service';
import { TokenService } from '../token.service';

@Injectable({
  providedIn: 'root',
})
export class AdvisorService {
  constructor() {}

  baseUrl = environment.URL_MULESOFT_ASESORES;
  GENERAL_CLIENT_ID = environment.GENERAL_CLIENT_ID;
  SESSION_ID = getSessionId().toString();

  _body = {};
  tokenService = inject(TokenService);
  private utils = inject(UtilsService);
  private http = inject(HttpClient);

  public getAdvisorInformation(sessionId: string, BodyAdvisor: any): Observable<any> {
    const urlWithTimestamp = `${this.baseUrl}/${BodyAdvisor}`;
    const headers = this.utils.getHeaders(sessionId || this.SESSION_ID);

    return this.http.get<any>(urlWithTimestamp, { headers }).pipe(
      retry(2),
      catchError((error) => {
        console.error(`Failed request for getAdvisorInformation ${BodyAdvisor}:`, error);
        return of(null); // Retornar null en caso de error para permitir que el flujo continúe
      }),
    );
  }

  public getAdvisorsList(sessionId: string): Observable<any> {
    const urlWithTimestamp = `${this.baseUrl}`;
    const headers = this.utils.getHeaders(sessionId || this.SESSION_ID);

    return this.http.get<any>(urlWithTimestamp, { headers }).pipe(
      retry(2),
      catchError((error) => {
        console.error(`Failed request for getAdvisorList: ${error}`);
        return of(null); // Retornar null en caso de error para permitir que el flujo continúe
      }),
    );
  }
}
